import { Component, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AppRouter } from "@app/app.router";
import { ENV } from "@env";
import { ChatConverter } from "@utils/converter/chat-converter";
import { FilesConverter } from "@utils/converter/files-converter";
import { Events } from "ionic-angular";
import { NavController } from "ionic-angular";
import { ConversationsProviderEvent } from "od-ts";
import { ApiResultError, CheckUtils, FilesProvider, FileVoData, JabberProvider } from "od-ts";
import { ChatStateData, FileData, MessageData } from "ui-ts";

@Component({
  selector: "od-com-footer",
  templateUrl: "footer.html",
  providers: []
})
export class Footer {
  private _nav: NavController;
  private _visible: boolean;
  private _viewName: string | undefined;
  private _lock: boolean;
  private _visibilityHandler: (view) => void;
  private _conversationLock: (res) => void;
  private _cancelHandler: () => void;

  constructor(
    private router: AppRouter,
    private jabber: JabberProvider,
    private _sanitizer: DomSanitizer,
    private filesProvider: FilesProvider,
    private events: Events) {
    this._lock = true;
    this.setup();
  }

  @Input() set nav(nav: NavController) {
    this.unbind();
    this._nav = nav;
    this.bind();
  }

  setup() {
    this._visibilityHandler = (view): void => {
      this._viewName = view == null ? undefined : view.name;
      this._lock = true;
      this._setVisible();
    };

    this._conversationLock = (res): void => {
      this._lock = res;
      this._setVisible();
    };
  }

  bind() {
    if (!CheckUtils.isEmpty(this._nav)) this._nav.viewWillEnter.subscribe(this._visibilityHandler);
    this.events.subscribe(ConversationsProviderEvent.LOCK, this._conversationLock);
  }

  unbind() {
    if (!CheckUtils.isEmpty(this._nav)) this._nav.viewWillEnter.unsubscribe();
    this.events.unsubscribe(ConversationsProviderEvent.LOCK, this._conversationLock);
  }

  onSend(message: MessageData) {
    const files: Array<File> = [];
    const filesData: Array<FileData> = [];

    if (!CheckUtils.isEmpty(message.files)) {
      message.files.forEach(attachment => filesData.push(attachment));
      FilesConverter.convertToFilesVoData(filesData).forEach(file => files.push(file));
    }

    let domParser = new DOMParser();
    const sources = [];
    const embedFiles: File[] = Footer.findEmbedFiles(domParser.parseFromString(message.text, "text/html"),
      (source: string) => {
        sources.push(source);
      });
    if (!CheckUtils.isEmpty(embedFiles)) {
      embedFiles.forEach(file => files.push(file));
    }

    if (!CheckUtils.isEmpty(files)) {
      this._cancelHandler = this.filesProvider.upload(files,
        (value: number) => {

        }, (code: ApiResultError) => {

        }, (values: FileVoData[]) => {

          if (!CheckUtils.isEmpty(values)) {
            if (!CheckUtils.isEmpty(filesData)) {
              for (var i = 0; i < filesData.length; i++) {
                message.files[i].identityKey = values[i].uid;
              }
            }
            if (!CheckUtils.areEmpty(files, sources)) {
              for (i = filesData.length; i < files.length; i++) {
                message.text = message.text.replace(sources[i - filesData.length], ENV.fileUrl + values[i].uid);
              }
            }
          }

          this.onSendMessage(message);

        }, true);
    } else {
      this.onSendMessage(message);
    }
  }

  private _setVisible() {
    this._visible = !CheckUtils.isEmpty(this._viewName) &&
      ((this._viewName === "MessagesPage" && !this._lock) ||
        this._viewName === "ConversationsPage" ||
        this._viewName === "WelcomePage");
  }

  private static findEmbedFiles(value: Document, callBack: (source: string) => void): File[] {
    let embedFiles = value.querySelectorAll("[src]"), fileList = [];
    let sources: string[] = [];
    for (var j = 0; j < embedFiles.length; j++) {
      var embedFile = embedFiles[j], source = embedFile.getAttribute("src"), name = null;
      if (source.indexOf("base64") > -1) {
        if (!CheckUtils.isEmpty(callBack)) callBack(source);
        if (embedFile.getAttribute("name") != null) {
          name = embedFile.getAttribute("name");
        } else if (embedFile.getAttribute("alt") != null) {
          name = embedFile.getAttribute("alt");
        } else if (embedFile.getAttribute("title") != null) {
          name = embedFile.getAttribute("title");
        } else {
          name = "embedFile" + j;
        }
        if (name != null && sources.indexOf(source) == -1) {
          sources.push(source);
          fileList.push(FilesConverter.convertFromSourceToFile(name, source));
        }
      }
    }
    return fileList;
  };

  private onSendMessage(message: MessageData) {
    this.jabber.send(ChatConverter.convertToMessageVoData(message), (conversation) => {
      if (!this.router.in("MessagesPage")) this.router.push("MessagesPage", { "id": conversation.uid });
    });
  }

  onState(chatState: ChatStateData) {
    this.jabber.sendChatState(ChatConverter.convertToJabberChatStateVoData(chatState));
  }

  onFocus(value: boolean) {
    let nodes: any = window.document.getElementsByTagName("ion-app");
    if (!CheckUtils.isEmpty(nodes)) {
      if (value) (nodes[0] as Element).classList.add("mode-edition");
      else (nodes[0] as Element).classList.remove("mode-edition");
    }
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/footer/footer.ts